import { registerEnum } from '@cbbt/lib-interface';
var OccupationRole;
(function (OccupationRole) {
    OccupationRole["ABLE_BODIED_UNEMPLOYED"] = "ABLE_BODIED_UNEMPLOYED";
    OccupationRole["AGRICULTURE"] = "AGRICULTURE";
    OccupationRole["APPLICANT_LIVING_ON_IND"] = "APPLICANT_LIVING_ON_IND";
    OccupationRole["CIVIL_SERVANT"] = "CIVIL_SERVANT";
    OccupationRole["CREATIVE"] = "CREATIVE";
    OccupationRole["DISABLED_UNEMPLOYED"] = "DISABLED_UNEMPLOYED";
    OccupationRole["DRIVER"] = "DRIVER";
    OccupationRole["EXECUTIVE"] = "EXECUTIVE";
    OccupationRole["FISHING"] = "FISHING";
    OccupationRole["GOVERNMENT_MINISTER"] = "GOVERNMENT_MINISTER";
    OccupationRole["GUARD"] = "GUARD";
    OccupationRole["HOUSEWIFE"] = "HOUSEWIFE";
    OccupationRole["LABOURER"] = "LABOURER";
    OccupationRole["MANAGER"] = "MANAGER";
    OccupationRole["MILITARY_NCO"] = "MILITARY_NCO";
    OccupationRole["MILITARY_NON_OFFICER_RANK"] = "MILITARY_NON_OFFICER_RANK";
    OccupationRole["MILITARY_OFFICER"] = "MILITARY_OFFICER";
    OccupationRole["NOT_WORKING"] = "NOT_WORKING";
    OccupationRole["OFFICE_CLERICAL_SECRETARIAL"] = "OFFICE_CLERICAL_SECRETARIAL";
    OccupationRole["OFFICE_MANAGERIAL"] = "OFFICE_MANAGERIAL";
    OccupationRole["OUTSIDE_WORKER"] = "OUTSIDE_WORKER";
    OccupationRole["OWNER_OF_BUSINESS"] = "OWNER_OF_BUSINESS";
    OccupationRole["POLITICIAN"] = "POLITICIAN";
    OccupationRole["PRODUCTION_WORKER"] = "PRODUCTION_WORKER";
    OccupationRole["PROFESSIONAL"] = "PROFESSIONAL";
    OccupationRole["RETIRED"] = "RETIRED";
    OccupationRole["SALES"] = "SALES";
    OccupationRole["SEMI_PROFESSIONAL"] = "SEMI_PROFESSIONAL";
    OccupationRole["SERVICES"] = "SERVICES";
    OccupationRole["SOCIAL_WORKER"] = "SOCIAL_WORKER";
    OccupationRole["TRADESMAN"] = "TRADESMAN";
    OccupationRole["UNKNOWN"] = "UNKNOWN";
    OccupationRole["WIDOW"] = "WIDOW";
})(OccupationRole || (OccupationRole = {}));
registerEnum(OccupationRole, 'OccupationRole');
export { OccupationRole };
//# sourceMappingURL=OccupationRole.js.map